// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"c71d80cd","437":"eeea1bf0","761":"460838ba","892":"e30cde24"}[chunkId] + ".chunk.css";
};